import React from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';
import DateUtils from 'lib/DateUtils';
import PhoneUtils from 'lib/PhoneUtils';
import StringUtils from 'lib/StringUtils';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { CustomerName } from 'utils/enum/ConversationEnum';
import {
    ListItem, ListItemAvatar, Avatar, Typography,
    Tooltip,
} from '@material-ui/core';
import If from 'components/widgets/conditional/If';
import { DIRECTION, STATUS } from 'utils/enum/MessageCenter';
import { modules } from 'utils/enum/modules';
import { Communication } from 'utils/enum/SubModule';
import MessageCenterStyle from 'styles/modules/crm/MessageCenterStyle';

const useStyles = makeStyles((theme) => MessageCenterStyle.messageItem(theme));
const MessageItem = ({ record, conversationId }) => {
    const classes = useStyles();
    const { smsChatId, sms } = record;
    const currentDate = DateUtils.toLocal(record.lastUpdated);
    const date = DateUtils.fromNow(currentDate);
    const { lotName } = sms.opportunity;
    const customerName = StringUtils.isEmpty(record.customer?.firstName) ? CustomerName.ANONYMOUS.toLowerCase() : record.customer.firstName;
    const shortCustomer = StringUtils.getCharacterFirstTwoWord(customerName);
    const isSelected = conversationId === smsChatId ? classes.conversationSelected : '';
    const cellPhone = record.customer?.cellPhone || PhoneUtils.formatPhone(record.cellPhone);
    const unreadMessage = sms.direction === DIRECTION.INCOMING && sms.status !== STATUS.READ;

    return (
        <ListItem
            className={clsx(classes.listItem, isSelected)}
            component={RouterLink}
            key={smsChatId}
            to={`/${modules.COMMUNICATION}/${Communication.SMS}/${record.smsChatId}?smsRead=${!unreadMessage}`}
        >
            <div className={classes.bodyConversation}>
                <ListItemAvatar>
                    <Avatar className={classes.avatar}>
                        {shortCustomer}
                    </Avatar>
                </ListItemAvatar>
                <div className={classes.customerDetails}>
                    <div className={classes.nameLastConnection}>
                        <Typography
                            variant="h6"
                            color="textPrimary"
                            noWrap
                            className={clsx(classes.customerName, { [classes.boldText]: unreadMessage })}
                        >
                            {customerName}
                        </Typography>
                        <Tooltip title={DateUtils.getFormattedDateInUserTimezone(record.lastUpdated)} placement="top">
                            <Typography
                                variant="caption"
                            >
                                {date}
                            </Typography>
                        </Tooltip>
                    </div>
                    <div className="d-flex-center-space-between">
                        <Typography
                            variant="subtitle2"
                            className={clsx(classes.cellPhone, { [classes.boldText]: unreadMessage })}
                            noWrap
                        >
                            {cellPhone}
                        </Typography>
                        <If condition={unreadMessage}>
                            <span className={classes.newMessage} />
                        </If>
                    </div>
                    <If condition={lotName !== null}><div className={classes.lotname}>{lotName}</div></If>
                </div>
            </div>
        </ListItem>
    );
};

MessageItem.propTypes = {
    record: PropTypes.object.isRequired,
    conversationId: PropTypes.string.isRequired,
};

export default MessageItem;
